import React, { useContext } from 'react';
import ThrottlingCheckbox from 'integrations/components/ThrottlingCheckbox';
import AdditionalFields from 'integrations/aws/common/AdditionalFields';
import FormDataContext from 'integrations/contexts/FormDataContext';

import { Input } from 'components/bootstrap';

import type { HandleFieldUpdateType, AdvancedOptionsContextType } from '../common/utils/types';
import { AdvancedOptionsContext } from '../common/context/AdvancedOptions';

interface Props {
  onChange: HandleFieldUpdateType;
  selectedContentTypes?: string;
}

const FormAdvancedOptions = ({ onChange, selectedContentTypes = '' }: Props) => {
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } =
    useContext<AdvancedOptionsContextType>(AdvancedOptionsContext);

  const { symantecSESThrottleEnabled, streamConnectionTimeout } = formData;

  const handleToggle: (visible: boolean) => void = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };

  return (
    <AdditionalFields title="Advanced Options" visible={isAdvancedOptionsVisible} onToggle={handleToggle}>
      <ThrottlingCheckbox
        id="symantecSESThrottleEnabled"
        defaultChecked={symantecSESThrottleEnabled?.value}
        onChange={onChange}
      />
      {(selectedContentTypes === 'events' ||
        selectedContentTypes === 'events,incidents' ||
        selectedContentTypes === 'incidents,events') && (
        <Input
          id="streamConnectionTimeout"
          name="streamConnectionTimeout"
          type="number"
          value={streamConnectionTimeout.value || streamConnectionTimeout.defaultValue || ''}
          min="1"
          max="60"
          step="1"
          onChange={onChange}
          required
          help="Event stream connection timeout in minutes, indicates how long the stream connection should be available."
          label="Event Stream Connection Timeout"
        />
      )}
    </AdditionalFields>
  );
};

export default FormAdvancedOptions;
